import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Charts from '../common/Charts/Charts';
import ReportSortOptions from '../common/ReportSort';
import { numberWithCommas } from '../../util/CommonUtils';
import { getDeepDiveReportName, getAttitudeChoiceLevel, processDataForDeepDive, getDeepDiveSortByIndexAndReach } from '../../util/Insight360Utils';
import * as insight360Actions from '../../actions/insight360Actions';
import closePopupIcon from '../../images/close-drawer-icon_default.png';
import infoIconWhite from '../../images/insight360/info-icon_white.png';
import {
  WEIGHTED_LABEL,
  REACH_LABEL,
  SAMPLE_LABEL,
  INSIGHT360_EXPLORE,
  INSIGHT360_PERSONA_CREATOR,
} from '../../constants';
import {
  WEIGHTED_INFO_MSG,
  REACH_INFO_MSG,
  SAMPLE_INFO_MSG,
  INSIGHTS_DEEP_DIVE_REPORT_NO_DATA_MSG,
} from '../../messages/messages';
import * as messages from '../../messages/ReportsMessages';

class ExplorerDeepDive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deepDiveData: [],
      noDataAvailabel: [],
      sortinfo: {
        index: props.deepDiveDetails.personaIndex,
        sortBy: props.sortByKey === 'index' ? _.upperFirst(props.sortByKey) :
        props.sortByKey,
       // sortBy: props.deepDiveDetails.section === INSIGHT_360_DEMO_LABEL ? 'pct' : 'Index',
        type: 'desc',
      },
      personaActiveSortIndex: undefined,
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
    };
  }

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  componentDidMount() {
    const promise = new Promise(resolve => {
      this.props.getDeepDiveDetailsData(resolve);
    });
    promise.then(deepDiveDetails => {
      const rawData = [];
      const noData = [];
      _.each(deepDiveDetails, data => {
        if (data.detail.length > 0) {
          rawData.push({
            categorySelected: data.detail[0].brandCategory,
            displayOptions: 'index',
            label: data.headers[1].label,
            reach: data.headers[1].pct,
            weighted: data.headers[1].weighted,
            sample: data.headers[1].sample,
            detailGroups: data.detail,
          });
        } else {
          rawData.push({
            categorySelected: '',
            displayOptions: 'index',
            label: data.headers[1].label,
            reach: data.headers[1].pct,
            weighted: data.headers[1].weighted,
            sample: data.headers[1].sample,
            detailGroups: data.detail,
          });
          noData.push({
            categorySelected: '',
            displayOptions: 'index',
            label: data.headers[1].label,
            reach: data.headers[1].pct,
            weighted: data.headers[1].weighted,
            sample: data.headers[1].sample,
            detailGroups: data.detail,
          });
        }
      });
      this.setState({
        deepDiveData: rawData,
        noDataAvailabel: noData,
      });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
  }

  getColor = index => {
    if (index === 0) {
      return '#fc946f';
    }
    if (index === 1) {
      return '#abcd75';
    }
    return '#57caef';
  }

  className = () => {
    if (this.props.personaHeader.length === 2) {
      return 'large-6 medium-6 small-6 columns';
    }

    if (this.props.personaHeader.length === 3) {
      return 'large-4 medium-4 small-4 columns';
    }
    return 'large-12 medium-12 small-12 columns';
  }

  classNameButtonContent = () => {
    if (this.props.personaHeader.length === 1) {
      return 'columns large-offset-3 medium-offset-3 small-offset-3 large-5 medium-5 small-5';
    }
    if (this.props.personaHeader.length === 2) {
      return 'columns large-offset-2 medium-offset-2 small-offset-2 large-8 medium-8 small-8';
    }
    return 'columns large-11 medium-11 small-11';
  }

  closePopupFn = () => {
    this.props.nodeRef.hide();
  }

  sortReportChart = sortVal => {
    if (sortVal !== undefined) {
      this.setState({
        sortinfo: {
          index: sortVal.index,
          sortBy: sortVal.sortBy,
          type: sortVal.type,
        },
        personaActiveSortIndex: undefined,
      });
    } else {
      this.setState({
        personaActiveSortIndex: undefined,
      });
    }
  };

  showReportSortDropdown = val => {
    this.setState({
      personaActiveSortIndex: val,
    });
  };

  isChartVisible = () => {
    const { deepDiveData, noDataAvailabel } = this.state;
    if ((noDataAvailabel.length !== deepDiveData.length) && deepDiveData.length > 0) {
      return true;
    }
    return false;
  }

  render() {
    const { personaHeader, pctPercentage, sample, weighted,
      deepDiveDetails, attitudeChoice, sortByKey } = this.props;
    const { deepDiveData, noDataAvailabel, sortinfo } = this.state;
    return (
      <div className="position-relative insight-deepDive-screen">
        <button className="deepDive-screen-close" onClick={this.closePopupFn}>
          <img className="sc-icon-img-sm" src={closePopupIcon} alt="close" />
        </button>
        <div className="row fullWidth deepDive-screen-body">
          {personaHeader.map((header, index) => {
            return (
              <div
                className={`deepDive-personaHeader ${this.className()}`}
                key={index}
                style={{ backgroundColor: this.getColor(index) }}
              >
                <div className="deepDive-topContent" title={header}>
                  {header}
                </div>
                <div className="row deepDive-buttomContent">
                  <div className={`${this.classNameButtonContent()}`}>
                    <div className="columns small-4 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                      <div>
                        {deepDiveData &&
                          deepDiveData.length > 0 &&
                          numberWithCommas(
                            Math.round(deepDiveData[index].sample)
                          )}
                      </div>
                    </div>
                    <div className="columns small-5 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                      <div>
                        {deepDiveData &&
                          deepDiveData.length > 0 &&
                          numberWithCommas(
                            Math.round(deepDiveData[index].weighted)
                          )}
                      </div>
                    </div>
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                      <div>
                        {deepDiveData &&
                          deepDiveData.length > 0 &&
                          Math.round(deepDiveData[index].reach * 10) / 10}
                        {deepDiveData && deepDiveData.length > 0 && (
                          <span>%</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="deepDive-sort-float-right margin-top-15">
                    <ReportSortOptions
                      btnClickFn={() => this.showReportSortDropdown(index)}
                      selectedRef={this.state.personaActiveSortIndex}
                      index={index}
                      sortReportChart={this.sortReportChart}
                      enableSortArrow={this.isChartVisible()}
                      // hidePercentageSort
                      // displaySortOption={deepDiveDetails.section === INSIGHT_360_DEMO_LABEL ?
                      // 'pct' : 'Index'}
                      displaySortOption={
                        sortByKey === 'index'
                          ? _.upperFirst(sortByKey)
                          : sortByKey
                      }
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="large-12 medium-12 small-12 columns deepDive-personaDetails">
          {deepDiveDetails.section !== 'Attitudes'
            ? `${deepDiveDetails.section} (${deepDiveDetails.category} )`
            : `${deepDiveDetails.section} (${deepDiveDetails.category} ) - ${attitudeChoice}`}
        </div>
        <div className="large-12 medium-12 small-12 columns deepDive-personaDetails deep-dive-graphHeight">
          {noDataAvailabel.length !== deepDiveData.length &&
            deepDiveData.length > 0 && (
              <Charts
                config={processDataForDeepDive(
                  {
                    rawData: deepDiveData,
                    selectedIndex:
                      sortByKey === 'index'
                        ? _.upperFirst(sortByKey)
                        : sortByKey,
                    // selectedIndex: 'Index',
                  },
                  this.updateAsteriskStatus,
                  sortinfo,
                  this.props.smartSearchStudy,
                  this.props.deepDiveDetails.section
                )}
              />
            )}
          {noDataAvailabel.length === deepDiveData.length &&
            noDataAvailabel.length > 0 && (
              <span>{INSIGHTS_DEEP_DIVE_REPORT_NO_DATA_MSG} </span>
            )}
          {deepDiveData.length === 0 && <span>Loading ...</span>}
          {(deepDiveData.length > 0 && !(noDataAvailabel.length === deepDiveData.length &&
            noDataAvailabel.length > 0)) && (
            <div className="large-12 medium-12 small-12 columns deepDive-footNote">
              <div className="row expanded position-relative font-11">
                <div className="i360-src-data-info small-5 column text-align-left">
                  {messages.INSIGHT_360_DEEPDIVE_CELL_COUNT_MSG}
                </div>
                <div className="small-7 column margin-top-5">
                  {this.props.sourceDataInfo(
                    'i360-src-data-info text-align-right'
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

ExplorerDeepDive.propTypes = {
  nodeRef: PropTypes.shape({}),
  personaHeader: PropTypes.instanceOf(Array),
  pctPercentage: PropTypes.instanceOf(Array),
  sample: PropTypes.instanceOf(Array),
  weighted: PropTypes.instanceOf(Array),
  deepDiveDetails: PropTypes.shape({}),
  getDeepDiveDetailsData: PropTypes.func,
  attitudeChoice: PropTypes.string,
  sourceDataInfo: PropTypes.func,
};

function mapStateToProps(state) {
  const selectedTab = state.insight360.deepDiveDetails.selectedTab;

  const personaLabel = () => {
    let personaLable;
    if (selectedTab === INSIGHT360_EXPLORE) {
      personaLable = state.insight360.insight360PersonaLabel;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      const creatorPersonaLabel = [];
      _.each(_.clone(state.insight360.personaCreator.segments.segments), segment => {
        creatorPersonaLabel.push(segment.title);
      });
      personaLable = creatorPersonaLabel;
    }
    return personaLable;
  };

  const personaExpression = () => {
    let personaExpression;
    if (selectedTab === INSIGHT360_EXPLORE) {
      const explorerPersonaobj = [];
      const explorerPersonaExpression = state.insight360.insight360PersonaExpression;
      const filter = state.insight360.insight360PersonaFilter;
      _.forEach(_.clone(explorerPersonaExpression), (personaExpression, index) => {
        let newExpression = `(${personaExpression})`;
        if (filter[index] !== '') {
          newExpression = `${newExpression} AND ${filter[index]}`;
        }
        explorerPersonaobj.push(newExpression);
      });
      personaExpression = explorerPersonaobj;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      const creatorPersonaExpression = [];
      _.each(_.clone(state.insight360.personaCreator.segments.segments), segment => {
        creatorPersonaExpression.push(segment.expression);
      });
      personaExpression = creatorPersonaExpression;
    }
    return personaExpression;
  };

  const personaSample = () => {
    let personaSample;
    if (selectedTab === INSIGHT360_EXPLORE) {
      personaSample = state.insight360.insight360PersonaSample;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      const creatorPersonaSample = [];
      _.each(_.clone(state.insight360.personaCreator.segments.segments), segment => {
        creatorPersonaSample.push(segment.sample);
      });
      personaSample = creatorPersonaSample;
    }
    return personaSample;
  };

  const personaWeighted = () => {
    let personaWeighted;
    if (selectedTab === INSIGHT360_EXPLORE) {
      personaWeighted = state.insight360.insight360PersonaWeighted;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      const creatorPersonaWeighted = [];
      _.each(_.clone(state.insight360.personaCreator.segments.segments), segment => {
        creatorPersonaWeighted.push(segment.weighted);
      });
      personaWeighted = creatorPersonaWeighted;
    }
    return personaWeighted;
  };

  const personaPct = () => {
    let personaPct;
    if (selectedTab === INSIGHT360_EXPLORE) {
      personaPct = state.insight360.insight360PersonaPct;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      const creatorPersonaPct = [];
      _.each(_.clone(state.insight360.personaCreator.segments.segments), segment => {
        creatorPersonaPct.push(segment.pct);
      });
      personaPct = creatorPersonaPct;
    }
    return personaPct;
  };

  const verticalPercentage = () => {
    let verticalPercentage;
    if (selectedTab === INSIGHT360_EXPLORE) {
      verticalPercentage = state.insight360.inight360VerticalPercent;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      verticalPercentage = state.insight360.personaCreator.inight360VerticalPercent;
    }
    return verticalPercentage;
  };

  const attitudeAgreeChoice = () => {
    let attitudeChoice;
    if (selectedTab === INSIGHT360_EXPLORE) {
      attitudeChoice = state.insight360.insight360AttitudeAgreeChoice;
    }
    if (selectedTab === INSIGHT360_PERSONA_CREATOR) {
      attitudeChoice = state.insight360.personaCreator.insight360AttitudeAgreeChoice;
    }
    return attitudeChoice;
  };

  const getAgreeChoiceLevelData = state => {
    let data = [];
    if (selectedTab === INSIGHT360_EXPLORE) {
      data = state.insight360.attitudes.length > 0 ?
       state.insight360.attitudes[0].attitudeGroups : [];
    } else {
      data = state.insight360.personaCreator.attitudes.length > 0 ?
      state.insight360.personaCreator.attitudes[0].attitudeGroups : [];
    }
    return data;
  };

  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: state.study.insight360study.pn,
    personaHeader: personaLabel(),
    personaExpressions: personaExpression(),
    pctPercentage: personaPct(),
    sample: personaSample(),
    weighted: personaWeighted(),
    deepDiveDetails: state.insight360.deepDiveDetails,
    verticalPercentage: verticalPercentage(),
    base: (selectedTab === INSIGHT360_EXPLORE) ? state.insight360.insight360Base : undefined,
    attitudeChoice: attitudeAgreeChoice(),
    // attitudeChoiceLevelData: state.insight360.attitudes.length > 0 ?
    // state.insight360.attitudes[0].attitudeGroups : [],
    getAgreeChoiceLevelData: getAgreeChoiceLevelData(state),
    sortByKey: getDeepDiveSortByIndexAndReach(state.insight360.deepDiveDetails,
      state.insight360.sortByIndexAndReach,
      state.insight360.personaCreator.sortByIndexAndReach),
    smartSearchStudy: state.study.insight360study,
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const getDeepDiveDetailsData = resolve => {
    dispatch(
      insight360Actions.getDeepDiveDetails(
        {
          token: stateProps.loginResponse.data.token,
          uid: stateProps.loginResponse.data.uid,
          accountId: stateProps.activeAccountId,
          productNo: stateProps.productNo,
          personaLabels: stateProps.personaHeader,
          personaExpressions: stateProps.personaExpressions,
          reportName: getDeepDiveReportName(stateProps.deepDiveDetails.section),
          level: getAttitudeChoiceLevel(stateProps.attitudeChoice, stateProps.getAgreeChoiceLevelData),
          category: stateProps.deepDiveDetails.category,
          pct: `>=${stateProps.verticalPercentage}`,
          base: stateProps.base,
          selectedTab: stateProps.deepDiveDetails.selectedTab,
          resolve,
        }),
    );
  };
  return { ...stateProps, ...ownProps, getDeepDiveDetailsData, };
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
)(ExplorerDeepDive);
